<template>
	<div
		class="create-new-container display-flex flex-column flex-justify-between"
		v-if="showCreateNewMode"
		v-click-outside="{ handler: dismissCreation }"
	>
		<v-form class="px-4 content-container pt-5 display-flex flex-row flex-wrap" @submit.prevent="saveIdea" ref="form" v-model="formValid">
			<div class="flex-col-10">
				<AppTextField
					class="title-area"
					v-model="title"
					placeholder="Add an idea"
					ref="input_title"
					:rules="[rules.required]"
					:hide-details="false"
				/>
				<AppTextArea class="description-area" v-model="description" placeholder="Add description" no-resize />
			</div>
			<SaveIdeaButton class="pointer-events-none flex-col-2 py-3 faded" />
		</v-form>
		<div class="px-4 footer-container display-flex flex-row flex-align-center flex-justify-space-between">
			<h3 class="reg footer-explanation">Visible to everyone in your workspace</h3>
			<DismissSaveButtons @dismiss="dismissCreation" @save="saveIdea" :isLoading="isLoading" />
		</div>
	</div>
	<div v-else @click="enterCreateNewMode" class="width-100 placeholder-container pl-4 display-flex flex-row flex-align-center">
		<h3 class="reg placeholder-text">Add an idea...</h3>
	</div>
</template>
<script>
import SaveIdeaButton from './SaveIdeaButton.vue';
import { mapActionsShorthand } from '@/store/utils/mappers';
import { createIdea } from '@/store/modules/inspirationCenter/actions.js';
import DismissSaveButtons from './DismissSaveButtons.vue';
export default {
	name: 'AddNewIdea',
	components: { SaveIdeaButton, DismissSaveButtons },
	methods: {
		...mapActionsShorthand({ createIdea }),
		dismissCreation() {
			this.showCreateNewMode = false;
			this.title = '';
			this.description = '';
		},
		async saveIdea() {
			this.$refs.form.validate();
			if (!this.formValid) {
				return;
			}
			this.isLoading = true;
			try {
				await this.createIdea({ params: { title: this.title, description: this.description } });
			} catch (e) {
				this.$toast.error(`Something went wrong, couldn't save your idea. Please try again later.`);
			} finally {
				this.isLoading = false;
			}
			this.dismissCreation();
		},
		enterCreateNewMode() {
			this.showCreateNewMode = true;
			this.$nextTick(() => {
				this.$refs.input_title.focus();
			});
		},
	},
	data() {
		return {
			showCreateNewMode: false,
			title: '',
			description: '',
			isLoading: false,
			rules: {
				required: (value) => !!value || 'Required.',
			},
			formValid: false,
		};
	},
};
</script>
<style lang="scss" scoped>
.create-idea-container {
	width: 100%;
	cursor: pointer;
	transition: 0.3s;
	border-radius: 9px;
	background: #ffffff;
	border: 1px solid #e7e7ec;
	&:hover {
		border: 1px solid #1c84fa;
	}
}
.placeholder-container {
	@extend .create-idea-container;
	height: 46px;
}
.create-new-container {
	@extend .create-idea-container;
	border: 1px solid #1c84fa;
}
.placeholder-text {
	opacity: 0.5;
	color: #292829;
}

.content-container {
	min-height: 166px;
	.title-area {
		::v-deep {
			.v-input {
				font-size: 14px;
			}
		}
	}
	.description-area {
		::v-deep {
			.v-input {
				font-size: 13px;
			}
		}
	}
}
.footer-container {
	height: 36px;
	background: #f7f7f9;
	border-radius: 0px 0px 9px 9px;
	border-top: 1px solid #e7e7ec;
}
.footer-explanation {
	color: #484848;
}
.faded {
	opacity: 0.5;
}
</style>
